export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-latin-ext-700-normal.woff2?90961fcb19a4664ae9a622ea178e4296";